__turbopack_context__.v({
  "content": "summarySection-module-scss-module__w9IfZa__content",
  "heading": "summarySection-module-scss-module__w9IfZa__heading",
  "summary": "summarySection-module-scss-module__w9IfZa__summary",
});
